import React from 'react';

const Failure = () => {
  return (
    <div>
      <h1>Pagamento falhou!</h1>
      <p>Ocorreu um problema ao processar seu pagamento. Por favor, tente novamente.</p>
    </div>
  );
};

export default Failure;